import { html, LitElement, PropertyValues } from "lit";
import { customElement, property } from "lit/decorators.js";
import { consume } from "@lit/context";

import { authContext, AuthState } from "@/context";

@customElement("sb-auth-state")
export class AuthStateElement extends LitElement {
  createRenderRoot() {
    return this;
  }

  private _cachedChildren: Node[] = [];

  @consume({ context: authContext, subscribe: true })
  @property({ attribute: false })
  auth?: AuthState;

  connectedCallback(): void {
    super.connectedCallback();
    if (this._cachedChildren.length === 0) {
      // detach and cache children once
      this._cachedChildren = Array.from(this.childNodes);
      this._cachedChildren.forEach((c) => this.removeChild(c));
    }
  }
  private tryRemoveFallback() {
    requestAnimationFrame(() => {
      const root = this as HTMLElement;

      const fallback = root.querySelector('[part="fallback"]');

      if (fallback) {
        fallback.remove();
      } else {
        console.warn("[sb-signup] fallback not found yet");
      }
    });
  }

  private syncAuthChildren() {
    if (!this.auth) return;

    if (this.auth.isAuthenticated) {
      this.querySelectorAll("sb-signed-out").forEach((el) => el.remove());
    } else {
      this.querySelectorAll("sb-signed-in").forEach((el) => el.remove());
    }
  }

  protected updated(_changedProperties: PropertyValues): void {
    if (_changedProperties.has("auth")) {
      this.syncAuthChildren();
      this.tryRemoveFallback();
    }
  }

  render() {
    if (!this.auth) {
      return html``;
    }

    return html` <div>${this._cachedChildren}</div> `;
  }
}
